module.exports = __webpack_public_path__ + "img/img_1.662cd789.jpg";